module.exports = __webpack_public_path__ + "img/no-time-slot.3653a697.svg";